import * as z from 'zod';

import { pickTicketsItemQuerySchema } from './pick-ticket-item-query-schema';

export const pickTicketsItemMutationSchema = pickTicketsItemQuerySchema
  .pick({
    id: true,
    inventory_id: true,
    quantity: true,
    sort_order: true,
  })
  .extend({
    pick_ticket_id: z.number().nullable(),
  });

export type PickTicketsItemMutationSchema = z.infer<typeof pickTicketsItemMutationSchema>;

export const pickTicketsItemCreateMutationSchema = pickTicketsItemMutationSchema.omit({ id: true });

export type PickTicketsItemCreateMutationSchema = z.infer<typeof pickTicketsItemCreateMutationSchema>;
